import classNames from "classnames";
import { ChangeEvent, MouseEvent, ReactNode } from "react";
import Form from "react-bootstrap/Form";
import { v4 as uuidv4 } from "uuid";
import "./index.scss";

interface PDLCheckboxProps {
  label?: ReactNode;
  indeterminate?: boolean;
  checked?: boolean;
  handleChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const PDLCheckbox = ({
  label,
  indeterminate = false,
  checked = false,
  handleChange = () => {},
}: PDLCheckboxProps) => {
  const handleClick = (evt: MouseEvent) => {
    evt.stopPropagation();
  };

  return (
    <div onClick={handleClick}>
      <Form.Check
        id={uuidv4()}
        type="checkbox"
        label={label}
        checked={checked}
        onChange={handleChange}
        className={classNames("pdl_dna_checkbox", {
          pdl_dna_checkbox_indeterminate: indeterminate,
        })}
      />
    </div>
  );
};

export default PDLCheckbox;
